// Focus the first text field in the currently-open modal (only one is ever open at a time).
// Call right after flipping a modal's open signal to true. A small delay lets the ?hidden
// attribute clear and the DOM settle before we focus.
export function focusModal(){
  setTimeout(() => {
    if (typeof document === 'undefined') return;   // env gone (SSR / a test torn down before this 40ms timer) — nothing to focus
    const card = document.querySelector('.modal-overlay:not([hidden]) .modal-card');
    const el = card && card.querySelector(
      'input:not([type=checkbox]):not([type=radio]):not([type=hidden]), textarea, select');
    if(el){ el.focus(); try { el.select && el.select(); } catch(_){} }
  }, 40);
}
